import styled from 'styled-components';

export const SecurityFeaturesButtonsStyles = styled.div`
	.buttons-container {
		background-color: white;
		border-top: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	}

	.button {
		flex-shrink: 0;
	}

	.button:disabled {
		pointer-events: all;
	}

	.tooltip-icon {
		&:hover {
			background-color: transparent;
		}
	}
`;
